export const drawGrid = (
  graphics: any,
  width: number,
  height: number
): void => {
  const gridSize = 20;
  // graphics.lineStyle(1, 0xdddddd, 0.3);

  for (let x = 0; x < width; x += gridSize) {
    graphics.moveTo(x, 0);
    graphics.lineTo(x, height);
  }

  for (let y = 0; y < height; y += gridSize) {
    graphics.moveTo(0, y);
    graphics.lineTo(width, y);
  }
};
